import {
  Button, Col, Drawer, Flex, Form, Input, Row, App,
} from 'antd';
import { updateCustomer } from 'api/customers';
import FormItem from 'components/FormItem';
import FormLayout from 'components/FormLayout';
import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';

function EditAccountModal({ open, customer, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { message } = App.useApp();

  useEffect(() => {
    if (open && customer) {
      const phone = customer.phone?.startsWith('+') ? customer.phone.slice(1) : customer.phone || '';
      form.setFieldsValue({
        name: customer.name || '',
        email: customer.email || '',
        phone: phone || '',
      });
    }
  }, [open, customer, form]);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = (values) => {
    setLoading(true);
    const payload = {
      name: values.name?.trim() || null,
      email: values.email?.trim() || null,
      phone: values.phone ? `+${values.phone}` : null,
    };
    updateCustomer(customer.id, payload)
      .then((res) => {
        const data = res?.data?.data ?? res?.data ?? res;
        onSuccess?.(data);
        message.success('Customer updated successfully');
        handleClose();
      })
      .catch((e) => {
        captureException(e);
        message.error(getHttpErrorMessage(e));
      })
      .finally(() => setLoading(false));
  };

  return (
    <Drawer
      title="Edit Account"
      width={572}
      onClose={handleClose}
      open={open}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <FormItem name="name" label="Name" fullWidth>
              <Input placeholder="Enter customer name" />
            </FormItem>
          </Col>
          <Col xs={24} lg={12}>
            <FormItem name="phone" label="Phone number" fullWidth>
              <PhoneInput
                country="us"
                buttonClass="phone-country"
                inputClass="input"
                inputProps={{ name: 'phone' }}
                inputStyle={{ width: '100%' }}
                placeholder="Enter phone number"
                preferredCountries={['us', 'ca']}
                enableSearch
                regions={['america', 'europe']}
                countryCodeEditable={false}
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem name="email" label="Email" fullWidth rules={[{ type: 'email', message: 'Please enter a valid email' }]}>
              <Input placeholder="Enter customer email" type="email" />
            </FormItem>
          </Col>
        </Row>
        <FormLayout.Footer>
          <Flex gap={16} justify="flex-end">
            <Button disabled={loading} onClick={handleClose}>
              Cancel
            </Button>
            <Button htmlType="submit" type="primary" loading={loading}>
              Save
            </Button>
          </Flex>
        </FormLayout.Footer>
      </Form>
    </Drawer>
  );
}

export default EditAccountModal;
